import Navbar from '../home/components/Navbar';
import Hero from './components/Hero';
import Content from './components/Content';
import FAQ from './components/FAQ';
import Footer from '../home/components/Footer';
import { useSchemaOrg, usePageMeta } from '../../utils/seo';

export default function PianoStorageLondon() {
  usePageMeta(
    'Piano Storage London | Climate-Controlled | Secure & Insured',
    'Secure climate-controlled piano storage in London. Short and long-term options. Fully insured £5M. Collection and delivery available. Free quote — 020 3441 9463.',
    'piano storage London, piano storage, secure piano storage London, long term piano storage London, grand piano storage London',
    'https://www.pianomovers.co.uk/piano-storage-london',
    'Piano Storage London | Climate-Controlled | Secure & Insured',
    'Secure climate-controlled piano storage London. Short and long-term. Fully insured £5M. Collection and delivery available. Free quote — 020 3441 9463.',
    'Piano Storage London | Climate-Controlled',
    'Secure climate-controlled piano storage London. Short and long-term, fully insured £5M. Free quote — 020 3441 9463.'
  );

  useSchemaOrg({
    type: 'FAQPage',
    data: {
      mainEntity: [
        {
          '@type': 'Question',
          name: 'How much does piano storage in London cost?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Piano storage costs in London vary depending on the type of piano, the duration of storage, and the specific facility. Upright piano storage typically starts from around £30 to £60 per week for short-term arrangements, while monthly rates for long-term piano storage London can range from £80 to £150 per month. Grand piano storage is priced higher due to the additional space required, starting from approximately £100 to £200 per month.',
          },
        },
        {
          '@type': 'Question',
          name: 'Is climate control important for piano storage?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Climate control is absolutely essential for safe piano storage. Pianos are highly sensitive to changes in temperature and humidity — fluctuations cause the wooden soundboard, bridges, and pin block to expand and contract, leading to cracked soundboards, loose tuning pins, and structural damage. A quality piano storage London facility maintains a consistent temperature of 18–22°C and relative humidity between 45% and 65% year-round.',
          },
        },
        {
          '@type': 'Question',
          name: 'How long can a piano be kept in storage?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'A piano can be stored safely for any length of time — from a few weeks to several years — provided the storage conditions are correct. In a properly climate-controlled piano storage London facility with stable temperature and humidity, the instrument will remain in good condition indefinitely. It is recommended to have the piano tuned and inspected by a qualified technician when it comes out of storage.',
          },
        },
        {
          '@type': 'Question',
          name: 'Do piano storage companies in London collect and deliver?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes, most specialist piano storage London companies offer a complete collection and delivery service as part of their storage package. A trained team of piano movers will come to your property, carefully wrap and load your piano, transport it to the storage facility, and deliver it back to you when required.',
          },
        },
        {
          '@type': 'Question',
          name: 'What insurance is provided for pianos in storage?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Reputable piano storage London facilities provide comprehensive insurance coverage for instruments in their care, typically covering the full replacement value of the piano against risks including fire, flood, theft, and accidental damage. Always confirm the exact level of insurance coverage provided before placing your piano in storage.',
          },
        },
      ],
    },
  });

  return (
    <div className="bg-[#f5f5f0] text-[#1a1916]">
      <Navbar />
      <Hero />
      <Content />
      <FAQ />
      <div className="bg-[#1a1916] py-4 text-center">
        <p className="text-[#d4d4ce] text-xs">
          Piano Movers UK is an independent guide to piano removal services in London.
        </p>
      </div>
      <Footer />
    </div>
  );
}